import { useQuery } from '@tanstack/react-query';
import { getMyReturnById } from '../../api/apiReturns';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetMyReturnById = (id) => {
    const { isAuthenticated } = useAuthContext();
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['my-return', id],
        queryFn: () => getMyReturnById(id),
        enabled: isAuthenticated && Boolean(id),
    });

    const returnRequest = data?.data?.data || null;
    return { returnRequest, isLoading, error, refetch };
};

export default useGetMyReturnById;
